import script from "./UserContactOca.vue?vue&type=script&setup=true&lang=js"
export * from "./UserContactOca.vue?vue&type=script&setup=true&lang=js"

import "./UserContactOca.vue?vue&type=style&index=0&id=638c9f74&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-638c9f74"]])

export default __exports__